module.exports = __webpack_public_path__ + "img/KMS-M-1.87b34f45.svg";